export const CALCULATION_DATA_FIELD_KEYS = {
  ECPA: 'calculation__ecpa',
  ECPA_IN_LOCAL_CURRENCY: 'calculation__ecpa_in_local_currency',
  ECPC: 'calculation__ecpc',
  ECPC_IN_LOCAL_CURRENCY: 'calculation__ecpc_in_local_currency',
  ECPI: 'calculation__ecpi',
  ECPI_IN_LOCAL_CURRENCY: 'calculation__ecpi_in_local_currency',
  ECPM: 'calculation__ecpm',
  ECPM_IN_LOCAL_CURRENCY: 'calculation__ecpm_in_local_currency',
  ROAS: 'calculation__roas',
  ROI: 'calculation__roi',

  CLICK_TO_INSTALL: 'calculation__click_to_install',
  CLICK_TO_OPEN: 'calculation__click_to_open',
  CLICK_TO_REINSTALL: 'calculation__click_to_reinstall',
  CLICK_TO_WEB_SESSION_START: 'calculation__click_to_web_session_start',

  CLICK_TOTAL: 'calculation__click_total',
  IMPRESSION_TOTAL: 'calculation__impression_total',
  INSTALL_TOTAL: 'calculation__install_total',
  OPEN_TOTAL: 'calculation__open_total',
  REINSTALL_TOTAL: 'calculation__reinstall_total',

  CLICK_BLOCKED_PERCENT: 'calculation__click_blocked_percent',
  INSTALL_BLOCKED_PERCENT: 'calculation__install_blocked_percent',
  IMPRESSION_BLOCKED_PERCENT: 'calculation__impression_blocked_percent',
  OPEN_BLOCKED_PERCENT: 'calculation__open_blocked_percent',
  REINSTALL_BLOCKED_PERCENT: 'calculation__reinstall_blocked_percent',

  VIEW_TO_ADD_PAYMENT_INFO: 'calculation__view_to_add_payment_info',
  VIEW_TO_ADD_TO_CART: 'calculation__view_to_add_to_cart',
  VIEW_TO_ADD_TO_WISHLIST: 'calculation__view_to_add_to_wishlist',
  VIEW_TO_CLICK: 'calculation__view_to_click',
  VIEW_TO_CLICK_AD: 'calculation__view_to_click_ad',
  VIEW_TO_DISMISSAL: 'calculation__view_to_dismissal',
  VIEW_TO_INITIATE_PURCHASE: 'calculation__view_to_initiate_purchase',
  VIEW_TO_INSTALL: 'calculation__view_to_install',
  VIEW_TO_OPEN: 'calculation__view_to_open',
  VIEW_TO_PURCHASE: 'calculation__view_to_purchase',
  VIEW_TO_RESERVE: 'calculation__view_to_reserve',
  VIEW_TO_SPEND_CREDITS: 'calculation__view_to_spend_credits',
  VIEW_TO_VIEW_AD: 'calculation__view_to_view_ad',
  VIEW_TO_VIEW_CART: 'calculation__view_to_view_cart',
} as const;
